import { useState } from "react";
import { useMutation } from "@apollo/client/react";
import { enqueueSnackbar } from "notistack";
import { mutations } from "@/graphql";
import type { AddEnergyDealMutation } from "@/types/graphql";

type AddDealResponse = {
  addEnergyDeal: AddEnergyDealMutation;
};

export const useAddDeal = (
  onCompleted: (data?: any) => void = () => {},
  onError: (error?: any) => void = () => {},
) => {
  const [success, setSuccess] = useState(false);
  const [resetForm, setResetForm] = useState(false);

  const [addDeal, { loading, data }] = useMutation<AddDealResponse>(
    mutations.addDeal,
    {
      onCompleted: (response) => {
        if (response.addEnergyDeal?.success) {
          setSuccess(true);
          setResetForm(true);
          setTimeout(() => {
            setSuccess(false);
            setResetForm(false);
          }, 5000);
        } else {
          setSuccess(false);
        }
        onCompleted(response);
      },
      onError: (err) => {
        setSuccess(false);
        onError(err);

        enqueueSnackbar(err.message, {
          variant: "error",
        });
      },
      errorPolicy: "all",
    },
  );
  return {
    addDeal,
    loading,
    success,
    data,
    resetForm,
  };
};
